<template>
  <div class="message-list">
    <h2 class="page-title">留言中心</h2>
    <div class="grid">
      <router-link
        v-for="msg in msgs"
        :key="msg.id"
        class="card"
        replace
        :to="{
          name: 'language_message',
          params: { language_id: msg.language_id },
        }"
      >
        <div class="card-header">
          <span v-if="msg.unread" class="dot"></span>
        </div>
        <p class="preview">
          <strong>{{ msg.parent_name }}</strong>
        </p>
        <p class="preview">{{ preview(msg.message) }}</p>
        <div class="time">{{ moment(msg.createdTime) }}</div>
      </router-link>

      <div v-if="msgs.length === 0" class="empty">
        暂无留言
      </div>
    </div>
  </div>
</template>

<script>
import { portalUrl } from '../static/config';
import moment from 'moment';
export default {
  name: 'MessageList',
  data() {
    return {
      msgs: [],
    };
  },
  mounted() {
    console.log('-----xxxxxx-----');
    this.axios
      .get(`${portalUrl}language/students/fetch_all_fist_messages`)
      .then((res) => {
        console.log('-----res', res);
        if (res.data.success) {
          this.msgs = res.data.data;
        }
      });
  },

  computed: {
    hasUnread() {
      return this.msgs.some((m) => m.unread);
    },
  },
  methods: {
    preview(text) {
      if (!text) return '';
      return text.length > 50 ? text.slice(0, 50) + '…' : text;
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD HH:mm');
    },
    markAllRead() {
      this.msgs.forEach((m) => (m.unread = false));
    },
  },
};
</script>

<style scoped>
.message-list {
  width: 375px;
  margin: 0 auto;
  padding: 24px;
  font-family: 'Helvetica Neue', sans-serif;
  box-sizing: border-box;
  background: #f5f6fa;
  height: 100vh;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.controls {
  margin-bottom: 16px;
  text-align: right;
}

.btn {
  background: #007aff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
}

.grid {
  display: grid;
  gap: 12px;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-decoration: none;
  color: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}

.preview {
  font-size: 14px;
  color: #666;
  margin: 6px 0;
  line-height: 1.4;
  text-align: left;
}

.time {
  font-size: 12px;
  color: #999;
  text-align: right;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #ff3b30;
  border-radius: 50%;
}
.empty {
  text-align: center;
  color: #aaa;
  font-size: 14px;
  padding: 20px 0;
}
</style>
